export enum ApiErrorCode {
  BAD_REQUEST = 'bad-request',
  NOT_FOUND = 'not-found',
  PAYMENT_FAILED = 'payment-failed',
  PAYMENT_REQUIRES_ACTION = 'payment-requires-action',
  TOO_MANY_REQUESTS = 'too-many-requests',
  FILE_TOO_LARGE = 'file-too-large',
  FILE_UPLOAD_ERROR = 'file-upload-error',
  UNSUPPORTED_FILE_TYPE = 'unsupported-file-type',
  RESET_SECURITY_FLOW_ERROR = 'reset-security-flow-error',
  INVALID_CALLOUT_RESPONSE = 'invalid-callout-response',
  INVALID_RULE = 'invalid-rule',
  NO_PAYMENT_METHOD = 'no-payment-method',
  DUPLICATE_ID = 'duplicate-id',
  DUPLICATE_EMAIL = 'duplicate-email',
  DUPLICATE_TAG_NAME = 'duplicate-tag-name',
  INTERNAL_SERVER_ERROR = 'internal-server-error',
  CANT_UPDATE_CONTRIBUTION = 'cant-update-contribution',
  CANT_UPDATE_NEWSLETTER_CONTACT = 'cant-update-newsletter-contact',
  CANT_UPDATE_NEWSLETTER_GROUPS = 'cant-update-newsletter-groups',
  CAPTCHA_FAILED = 'captcha-failed',
  CAPTCHA_REQUIRED = 'captcha-required',
}
